// Gestione del logo dell'accordo (impostazioni.logo = { nome, file })

export const LOGO_VUOTO = { nome: "", file: "" };

export const LOGO_TIPI = ["image/png", "image/jpeg"];
export const LOGO_MAX_SIZE = 2 * 1024 * 1024; // 2 MB

// L'immagine e' diversa da quella salvata (o non c'era un logo salvato)
export const logoCambiato = (logo, logoSalvato) =>
  !!logo?.file && logo.file !== logoSalvato?.file;

// Primo errore del logo, null se valido o non modificato.
// Se sostituisce un logo gia' salvato anche il nome deve cambiare
export const erroreLogo = (logo, logoSalvato) => {
  if (!logoCambiato(logo, logoSalvato)) return null;
  const nome = (logo.nome || "").trim();
  if (!nome) return "Inserisci il nome del logo.";
  if (logoSalvato?.file && nome === (logoSalvato.nome || "").trim()) {
    return "Il nome del logo deve essere diverso da quello attuale.";
  }
  return null;
};
